<ng-container *ngIf="article$ | async as article; else loading">
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url('{{ loadImageFeatured(article.featured_image) }}')">
        </div>
        <!-- /.page-header__bg -->
        <div class="container box">
            <h3 class="page-header__title bw-split-in-left titre"
                [ngClass]="titleSizeClass(translateField(article.title))">{{translateField(article.title)}}</h3>
            <ul class="careox-breadcrumb list-unstyled">
                <li><span></span></li>
            </ul><!-- /.thm-breadcrumb list-unstyled -->
        </div><!-- /.container -->
    </section><!-- /.page-header -->

    <section class="blog-details">
        <div class="container">
            <div class="row gutter-y-60">
                <div class="col-lg-8">
                    <div class="blog-details__content">
                        <div class="blog-details__image">
                            <img src="{{ loadImageFeatured(article.featured_image) }}" alt="arp">
                        </div><!-- /.blog-card__image -->
                        <ul class="list-unstyled blog-details__top-meta">
                            <li class="blog-card-list__meta__cats"><a href="blog-grid.html">{{
                                    (article.category!=null)?translateField(article.category!.name):''
                                    }}</a></li>
                            <li><i class="icofont-ui-calendar"></i>{{ article.created_at | localDate:'fr' }}
                            </li>
                        </ul><!-- /.list-unstyled blog-card__top-meta -->
                        <h3 class="blog-details__title"> {{translateField(article.title)}}</h3>
                        <div class="blog-details__content" [innerHTML]="translateField(article.content)"></div>
                        <div class="blog-details__meta" style="display: none;">
                            <div class="blog-details__tags">
                                <h4 class="blog-details__tags__title">Tags</h4><!-- /.blog-details__tags__title -->
                                <div class="sidebar__tags">
                                    <a href="blog-list-right.html">Beauty</a>
                                    <a href="blog-list-right.html">Massage</a>
                                </div><!-- /.sidebar__projects -->
                            </div><!-- /.blog-details__tags -->
                            <div class="blog-details__social">
                                <a href="https://facebook.com" style="--accent-color: #ffa415;">
                                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                    <span class="sr-only">Facebook</span>
                                </a>
                                <a href="https://twitter.com" style="--accent-color: #fc5528;">
                                    <i class="fab fa-twitter" aria-hidden="true"></i>
                                    <span class="sr-only">Twitter</span>
                                </a>
                                <a href="https://pinterest.com" style="--accent-color: #8139e7;">
                                    <i class="fab fa-pinterest-p" aria-hidden="true"></i>
                                    <span class="sr-only">Pinterest</span>
                                </a>
                                <a href="https://instagram.com" style="--accent-color: #44c895;">
                                    <i class="fab fa-instagram" aria-hidden="true"></i>
                                    <span class="sr-only">Instagram</span>
                                </a>
                            </div><!-- /.blog-details__social -->
                        </div><!-- /.blog-details__meta -->
                    </div><!-- /.blog-details -->
                </div><!-- /.col-lg-8 -->
                <div class="col-lg-4">
                    <app-sidebar-blog></app-sidebar-blog>
                </div><!-- /.col-lg-4 -->
            </div><!-- /.row -->
        </div><!-- /.container -->
    </section><!-- /.blog-details -->




    <section class="gallery-one" *ngIf="article.gallery">
        <div class="container">

            <owl-carousel-o [options]="customOptions">

                <ng-container *ngFor="let photo of article.gallery; let i = index">
                    <ng-template carouselSlide>
                        <div class="gallery-one__card">
                            <img [src]="loadImageFeatured(photo)" alt="">
                            <div class="gallery-one__card__hover">
                                <a [href]="loadImageFeatured(photo)" class="img-popup"
                                   (click)="openLightbox(i, article.gallery, $event)">
                                    <span class="gallery-one__card__icon"></span>
                                </a>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>

            </owl-carousel-o>

        </div>
    </section>


</ng-container>


<ng-template #loading>
     <app-loading></app-loading>
</ng-template>

<!-- ── Visionneuse de la galerie ─────────────────────────────────────── -->
<app-lightbox
    [media]="lightboxMedia"
    [(index)]="lightboxIndex"
    [open]="lightboxOpen"
    (closed)="lightboxOpen = false">
</app-lightbox>
